import { defineComponent as _defineComponent } from 'vue'
import {
        THGCO2Equivalent,
        THGUpdateCO2EquivalentData,
    } from '@/interfaces/thg/THGCO2Equivalent';
    import { onMounted, ref } from 'vue';
    import THGCO2EquivalentForm from '@/components/thg/co2_equivalents/THGCO2EquivalentForm.vue';
    import { fetchTHGCO2Equivalent, saveTHGCO2Equivalent } from '@/api/thg/co2_equivalents';
    import { useRoute, useRouter } from 'vue-router/composables';
    import emitter from '@/utils/mitt';
    import { alertError } from '@/utils/dialogs';
    import { ToastProgrammatic as Toast } from 'buefy';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCO2Equivalent',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();
    const equivalent = ref<THGCO2Equivalent | null>(null);

    async function saveEquivalent() {
        if (!equivalent.value) {
            throw new Error('equivalent is undefined');
        }

        emitter.emit('showLoader');

        // create the update data
        const updateData: THGUpdateCO2EquivalentData = {
            year: equivalent.value.year,
            tons: equivalent.value.tons,
            price: equivalent.value.price,
        };

        if (!equivalent.value._id) {
            throw new Error('Equiv ID is undefined');
        }

        // do the actual update
        const response = await saveTHGCO2Equivalent(equivalent.value._id, updateData);

        if (response.status !== 200) {
            if (response.status === 409) {
                alertError(
                    'Fehler',
                    `Ein CO₂-Äquivalent für das Jahr <b>${updateData.year}</b> existiert bereits.`,
                );
            } else {
                alertError('Fehler', 'Fehler beim Speichern des CO₂-Äquivalents.');
            }
        } else {
            Toast.open({ type: 'is-success', message: 'CO₂-Äquivalent erfolgreich gespeichert.' });
            router.push({ name: 'thgco2equivalentslist' });
        }

        emitter.emit('hideLoader');
    }

    onMounted(async () => {
        const response = await fetchTHGCO2Equivalent(route.params.co2EquivalentId);
        const equivalentObj = response.parsedBody;

        if (!equivalentObj) {
            throw new Error('Error while fetching user.');
        }

        equivalent.value = equivalentObj;
    });

return { __sfc: true,route, router, equivalent, saveEquivalent, THGCO2EquivalentForm }
}

})